import React, { useEffect, useState } from "react";
import "./LoanPaymentBreakdown.scss";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  Grid,
  MenuItem,
  Paper,
  TablePagination,
} from "@mui/material";

const columns = [
  { id: "term", label: "Term" },
  { id: "dueDate", label: "Due Date" },
  { id: "requiredPayment", label: "Required Payment" },
  { id: "amountPaid", label: "Amount Paid" },
  { id: "outstandingAmount", label: "Outstanding Amount" },
  { id: "status", label: "Status" },
];

const rows = Array.from({ length: 13 }, (_, index) => ({
    id: index + 1,
    term: "Cell",
    dueDate: "Cell",
    requiredPayment: "Cell",
    amountPaid: "Cell",
    outstandingAmount: "Cell",
    status: "Cell",
}));

const loanColumns = [
    { id: "planType", label: "Plan Type" },
    { id: "totalLoanRemaining", label: "Total Loan Remaining" },
    { id: "weeklyPayment", label: "Weekly Payment" },
    { id: "potentialSavings", label: "Potential Savings" },
];

const loanRows = [
    {
      planType: "3 Month",
      totalLoanRemaining: "-",
      weeklyPayment: "-",
      potentialSavings: "-",
    },
    {
      planType: "6 Month",
      totalLoanRemaining: "-",
      weeklyPayment: "-",
      potentialSavings: "-",
    },
    {
      planType: "1 Year",
      totalLoanRemaining: "-",
      weeklyPayment: "-",
      potentialSavings: "-",
    },
];

const transactionColumns = [
    { id: "transactionId", label: "Transaction ID" },
    { id: "date", label: "Date" },
    { id: "transactionAmount", label: "Transaction Amount" },
    { id: "status", label: "Status" },
    { id: "refundedAmount", label: "Refunded Amount" },
    { id: "refund", label: "Refund" },
];

const transactionRows = [
    {
      transactionId: "D2A6DZXU",
      date: "2024-01-25",
      transactionAmount: "$1000",
      status: "COMPLETED",
      refundedAmount: "0",
      refund: "0",
    },
    {
      transactionId: "D2A6DZXU",
      date: "2024-01-25",
      transactionAmount: "$1000",
      status: "COMPLETED",
      refundedAmount: "0",
      refund: "0",
    },
    {
      transactionId: "D2A6DZXU",
      date: "2024-01-25",
      transactionAmount: "$1000",
      status: "COMPLETED",
      refundedAmount: "0",
      refund: "0",
    },
    {
      transactionId: "D2A6DZXU",
      date: "2024-01-25",
      transactionAmount: "$1000",
      status: "COMPLETED",
      refundedAmount: "0",
      refund: "0",
    },
];

const LoanPaymentBreakdown = ({selectedLoan}) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [customerTabsHeight, setCustomerTabsHeight] = useState(
        window.innerHeight * 0.6
    );


    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(()=> {
        console.log("selectedLoan-----------",selectedLoan);
    },[selectedLoan])

    return (
        <Box
        sx={{
            padding: "0px 22px",
            // marginBottom: "60px",
            height: "calc(100vh - 80px)",
            overflow: "hidden",
            overflowY:"auto"
        }}
        >
        <Box
            sx={{
            display: "flex",
            flexDirection: "row",
            gap: "16px",
            height: "100%",
            }}
        >
            {/* Left Side: Loan Details & Table */}
            <Box
            sx={{
                flex: "1",
                maxWidth: "50%",
                overflow: "hidden",
                padding: "15px",
                backgroundColor: "white",
                display: "flex",
                flexDirection: "column", // Stack loan details & table
                height: "100%", // Ensure it does not overflow
            }}
            >
            <Typography
                sx={{
                fontFamily: "'Nunito'",
                fontSize: "21.5px",
                color: "#3A3A3A",
                }}
            >
                Loan Details
            </Typography>

                {/* Loan Info Grid */}
                <Box sx={{ flexShrink: 0 }} className="mt-2">
                    <Grid container spacing={1}>
                    {[
                        { label: "Loan Request ID", value: "1000" },
                        { label: "Loan Currency", value: "USD" },
                        { label: "Loan Amount", value: "12,000" },
                        { label: "Loan Amount", value: "12,000" },
                        { label: "Reference No", value: "D2A6DZXUZ" },
                        { label: "Arrears", value: "0" },
                        { label: "Penalties", value: "0" },
                        { label: "Reference No", value: "D2A6DZXUZ" },
                        { label: "Arrears", value: "0" },
                        { label: "Penalties", value: "0" },
                    ].map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                        <Box
                            sx={{
                                padding: "6px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                            }}
                        >
                            <Typography variant="caption" sx={{ fontWeight: "bold", fontSize:"14px" }}>
                            {item.label}
                            </Typography>
                            <Typography variant="body1" sx={{ fontSize:"14px" }}>{item.value}</Typography>
                        </Box>
                        </Grid>
                    ))}
                    </Grid>
                </Box>
            
                {/* Loan Details Table */}
                <Box sx={{ flexGrow: 1, maxHeight: "35vh" }} className="mt-4">
                    {" "}
                    <Box sx={{ width: "100%"}}>
                    <TableContainer sx={{ maxHeight: "35vh", overflow: "auto"}} component={Paper} >
                        <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} sx={{ fontWeight: "bold" }}>
                                {column.label}
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                                <TableRow hover key={row.id}>
                                {columns.map((column) => (
                                    <TableCell key={column.id}>
                                    {row[column.id]}
                                    </TableCell>
                                ))}
                                </TableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className="loan-details-table-pagination d-flex"
                    />
                    </Box>
                </Box>
            </Box>

            {/* Right Side */}
            <Box
            sx={{
                flex: 1,
                minWidth: "50%",
                backgroundColor: "white",
                overflow: "auto",
                marginLeft: "15px",
                height: "100%",
                padding: "15px",
            }}
            >
                <Box>
                    <Typography
                        sx={{
                        fontFamily: "'Nunito'",
                        fontSize: "21.5px",
                        color: "#3A3A3A",
                        }}
                    >
                        Loan Plans
                    </Typography>
                    <TableContainer component={Paper} sx={{ maxHeight: 200, overflow: "auto" }}>
                        <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                            {loanColumns.map((column) => (
                                <TableCell key={column.id} sx={{ fontWeight: "bold" }}>
                                {column.label}
                                </TableCell>
                            ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loanRows.map((row, index) => (
                            <TableRow hover key={index}>
                                {loanColumns.map((column) => (
                                <TableCell key={column.id}>{row[column.id]}</TableCell>
                                ))}
                            </TableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* Recent Transactions */}
                <Box className="mt-3">
                    <Typography
                        sx={{
                        fontFamily: "'Nunito'",
                        fontSize: "21.5px",
                        color: "#3A3A3A",
                        }}
                    >
                        Recent Transactions
                    </Typography>

                    <TableContainer component={Paper} sx={{ maxHeight: 300, overflow: "auto" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                {transactionColumns.map((column) => (
                                    <TableCell key={column.id} sx={{ fontWeight: "bold" }}>
                                    {column.label}
                                    </TableCell>
                                ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {transactionRows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                    <TableRow hover key={index}>
                                    {transactionColumns.map((column) => (
                                        <TableCell key={column.id}>{row[column.id]}</TableCell>
                                    ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* Payment Form */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 3 }}>
                    <TextField label="Payment ID" variant="outlined" size="small" />
                    <TextField label="Payment Amount" variant="outlined" size="small" />
                    <Button variant="contained">Record Payment</Button>
                </Box>
            </Box>
        </Box>
        </Box>
    );
};

export default LoanPaymentBreakdown;
